import { IS_BIZ_USER, IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { features } from 'reactApp/mail-features';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';

const constraints = !IS_BIZ_USER && !IS_ONPREMISE;

// CLOUDWEB-19004
// Модалка Сейфа при очистке
export const isSafeEnabled: boolean = constraints && features.has('overquota-safe-ab');
export const safeCheckIsEmpty: boolean = isSafeEnabled && features.has('safe-check-is-empty');

const tariffIds = {
    month: ['W256G1m_single_quota_2022_cloud', 'W512G1m_single_quota_2022_cloud', 'W1T1m_single_quota_2022_cloud'],
    year: ['W256G1y_single_quota_2022_cloud', 'W512G1y_single_quota_2022_cloud', 'W1T1y_single_quota_2022_cloud'],
};

export const overquotaSafeTariffIds: YearAndMonthProductIds = features.getAsJSON('overquota-safe-tariffs', tariffIds);

export const overquotaSafeTip: boolean = isSafeEnabled && features.has('overquota-safe-tip');
export const overquotaSafeTipEveryDay: boolean = constraints && features.has('overquota-safe-tip-everay-day');

export const helpSafeHref = features.getAsString('safe-promo-help', 'https://help.mail.ru/cloud_web/size/safe/');
